"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getSubmissionUpdatedEvent_1 = require("../helpers/getEvent/getSubmissionUpdatedEvent");
const getState_1 = require("../helpers/getState");
function applyUnsubmitCommand(command, user, content, states) {
    const events = [];
    const { contentId, userId, timeStamp } = command;
    const currentContent = getContent_1.getContentByContentId(content, contentId);
    let isAnySubmissionUpdated = false;
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const childrenStates = getState_1.getChildrenStatesForContentByUserId(draftStates, currentContent, userId);
        childrenStates.forEach(childState => {
            if (new Date(childState.updatedAt).getTime() > new Date(timeStamp).getTime()) {
                return;
            }
            const latestSubmission = childState.submissions[0];
            latestSubmission.rawScore = 0;
            latestSubmission.progressMeasure = 0;
            latestSubmission.reviewsReceivedCount = 0;
            latestSubmission.lastAccessedOn = latestSubmission.updatedAt = timeStamp;
            childState.rawScore = 0;
            childState.progressMeasure = 0;
            childState.reviewsReceivedCount = 0;
            childState.actualSubmit = false;
            delete childState.gradedBy;
            childState.lastAccessedOn = childState.updatedAt = timeStamp;
            isAnySubmissionUpdated = true;
        });
        state.lastAccessedOn = timeStamp;
    });
    if (isAnySubmissionUpdated) {
        const { companyId } = user;
        const contentType = getContentType_1.getContentType(currentContent);
        const submissionUpdatedEvent = getSubmissionUpdatedEvent_1.getSubmissionUpdatedEvent(command, companyId, userId, contentId, contentType);
        events.push(submissionUpdatedEvent);
    }
    return { states: updatedStates, events, enrolments: [], stateInteractions: [] };
}
exports.applyUnsubmitCommand = applyUnsubmitCommand;
//# sourceMappingURL=applyUnsubmitCommand.js.map